import React, { useEffect, useLayoutEffect, useState } from 'react';

import useGenerateExternalUrl from 'hooks/useGenerateExternalUrl';
import { getStorageDataSnapshot } from 'hooks/useStorageData';
import FilesList from './FilesList';

const hasStoredFirmIdentity = () => {
  const storageData = getStorageDataSnapshot();
  return Boolean(storageData?.company_url || storageData?.cpa_uuid);
};

const FilesRedirect = () => {
  const filesUrl = useGenerateExternalUrl('/files');

  useLayoutEffect(() => {
    window.location.replace(filesUrl);
  }, [filesUrl]);

  return null;
};

export default function FilesRoute(props) {
  const [hasFirmIdentity, setHasFirmIdentity] = useState(
    hasStoredFirmIdentity
  );

  useEffect(() => {
    if (hasFirmIdentity) {
      return undefined;
    }

    const refreshFirmIdentity = () => {
      setHasFirmIdentity(hasStoredFirmIdentity());
    };

    window.addEventListener('storage', refreshFirmIdentity);
    return () => window.removeEventListener('storage', refreshFirmIdentity);
  }, [hasFirmIdentity]);

  // The firm app owns Files; without a stored firm identity there is no URL to send the user
  // to yet, so the legacy list renders until one arrives.
  if (hasFirmIdentity) {
    return <FilesRedirect />;
  }

  return <FilesList {...props} />;
}
